import {useQuery} from 'react-query'
import {FacilityEditModalForm} from './FacilitieEditModalForm'
import {isNotEmpty, QUERIES} from '../../../../../_dashboard/helpers'
import {useListView} from '../core/ListViewProvider'
import { getOneById } from '../../../../services/common_requests'
import { initialFacility } from '../core/_models'

const FacilityEditModalFormWrapper = () => {
  const {itemIdForUpdate, setItemIdForUpdate} = useListView()
  const enabledQuery: boolean = isNotEmpty(itemIdForUpdate)
  const {
    isLoading,
    data: Facility,
    error,
  } = useQuery(
    `${QUERIES.FACILITIES_LIST}-Facility-${itemIdForUpdate}`,
    () => {
      return getOneById(itemIdForUpdate,"/facilities")
    },
    {
      cacheTime: 0,
      enabled: enabledQuery,
      onError: (err) => {
        setItemIdForUpdate(undefined)
        console.error(err)
      },
    }
  )

  if (!itemIdForUpdate) {
    return <FacilityEditModalForm isFacilityLoading={isLoading} Facility={{...initialFacility, _id: undefined}} />
  }

  if (!isLoading && !error && Facility) {
    return <FacilityEditModalForm isFacilityLoading={isLoading} Facility={Facility} />
  }

  return null
}

export {FacilityEditModalFormWrapper}
